import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzPopconfirmModule, NzToolTipModule } from 'ng-zorro-antd';

import { AtxPopConfirmComponent } from './components';
import { AtxPopConfirmDirective } from './directives';

@NgModule({
    imports: [
        CommonModule,
        NzToolTipModule,
        NzPopconfirmModule,
    ],
    declarations: [
        AtxPopConfirmDirective,
        AtxPopConfirmComponent,
    ],
    exports: [
        AtxPopConfirmComponent,
    ],
})

export class AtxPopConfirmModule {}
